/* eslint-disable react/prop-types */
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { format, isValid } from 'date-fns'
import { renderRouteRole } from '../../../util/utils'

import BadgeGlobal from '../../components/Badge'
import SelectField from '../../components/SelectField'
import { fetchUsers, makeReport } from '../UserActions'
import BaseFilter from '../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Icon from '@mdi/react'
import {
  mdiFilterMultiple,
  mdiMagnifyExpand,
  mdiMicrosoftExcel,
  mdiNoteEditOutline,
} from '@mdi/js'
import { InputAdornment, Typography } from '@material-ui/core'
import colors from '../../../assets/colors'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

export default function Filter({ classes }) {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()

  const styles = filterStylesComponents()

  const role = useSelector(state => state.auth.role) || {}
  const roles = useSelector(state => state.user.roles)

  const filters = useQueryParams(location?.search)

  const roleFiltered = useMemo(() => {
    if (!roles?.length) return ''
    if (!filters.role_id) return ''
    return roles?.find(r => r?.id == filters?.role_id)
  }, [filters])

  const [open, setOpen] = useState(false)

  const [dateForm, setDateForm] = useState({
    last_seen_at_date_start: filters?.last_seen_at_date_start
      ? new Date(`${filters.last_seen_at_date_start} 00:00:00`)
      : null,
    last_seen_at_date_end: filters?.last_seen_at_date_end
      ? new Date(`${filters.last_seen_at_date_end} 00:00:00`)
      : null,
  })

  const handleChangeUserType = (name, role) => {
    const data = { ...filters, [name]: role?.id || '' }
    handleSubmit(data)
  }

  const handleOpen = () => {
    setOpen(!open)
  }

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    searchParams.set('page', 1)
    if (open) handleOpen()
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const onSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    values.last_seen_at_date_start =
      dateForm.last_seen_at_date_start &&
      isValid(dateForm.last_seen_at_date_start)
        ? format(dateForm.last_seen_at_date_start, 'yyyy-MM-dd')
        : ''
    values.last_seen_at_date_end =
      dateForm.last_seen_at_date_end &&
      isValid(dateForm.last_seen_at_date_end)
        ? format(dateForm.last_seen_at_date_end, 'yyyy-MM-dd')
        : ''

    handleSubmit({ ...filters, ...values })
  }

  return (
    <>
      <BaseFilter>
        <Grid item container xs={12} alignItems="center">
          <Grid item container spacing={1} xs={6}>
            <Grid item xs={6}>
              <form onSubmit={onSubmit}>
                <TextField
                  label="Filtre por nome"
                  className={classes.inputFilter}
                  fullWidth
                  name="name"
                  defaultValue={filters?.name}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton type="submit">
                          <Icon path={mdiMagnifyExpand} size={1} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </form>
            </Grid>
            <Grid item xs={6}>
              <SelectField
                options={roles}
                setForm={handleChangeUserType}
                data={roleFiltered}
                name="role_id"
                label="Filtre por função"
              />
            </Grid>
          </Grid>
          <Grid
            item
            className={styles.areaButtons}
            xs={6}
            container
            justifyContent="flex-end"
          >
            <IconButton className={styles.btnMoreFilters} onClick={handleOpen}>
              <Icon
                path={mdiFilterMultiple}
                size={1}
                color={colors.secondary}
              />
              Outros Filtros
            </IconButton>

            <IconButton
              className={styles.btnAdd}
              onClick={() => dispatch(makeReport(filters))}
            >
              <Icon path={mdiMicrosoftExcel} size={1} /> Download
            </IconButton>

            {canCreate('usuarios', permissionUser) && (
              <IconButton
                color="primary"
                variant="contained"
                component={Link}
                to="/users/new"
                className={styles.btnAdd}
              >
                <Icon path={mdiNoteEditOutline} size={1} />
                Cadastrar
              </IconButton>
            )}
          </Grid>
        </Grid>
      </BaseFilter>

      <BaseFilterModal open={open} handleOpen={handleOpen} title="FILTRO">
        <Grid item xs={12} style={{ width: '420px' }}>
          <form onSubmit={onSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography
                  style={{ fontSize: '16px', fontWeight: 'normal' }}
                  color={colors.primary}
                >
                  Utilize os campos abaixo para encontrar <br /> um usuário
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Nome"
                  className={classes.inputFilter}
                  fullWidth
                  defaultValue={filters?.name}
                  name="name"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Email"
                  className={classes.inputFilter}
                  fullWidth
                  defaultValue={filters?.email}
                  name="email"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Cliente Lav."
                  className={classes.inputFilter}
                  fullWidth
                  name="laundry_client"
                  defaultValue={filters?.laundry_client}
                />
              </Grid>

              <Grid item xs={6}>
                <SelectField
                  options={roles}
                  setForm={handleChangeUserType}
                  data={roleFiltered}
                  name="role_id"
                  label="Filtre por função"
                />
              </Grid>

              {renderRouteRole(['administrador'], role) && (
                <>
                  <Grid item xs={6}>
                    <KeyboardDatePicker
                      clearable
                      value={dateForm.last_seen_at_date_start}
                      label="Último Acesso - Início"
                      fullWidth
                      clearLabel="Limpar"
                      invalidDateMessage="Data inválida"
                      autoOk
                      onChange={date =>
                        setDateForm({
                          ...dateForm,
                          last_seen_at_date_start: date,
                        })
                      }
                      format="dd/MM/yyyy"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <KeyboardDatePicker
                      clearable
                      value={dateForm.last_seen_at_date_end}
                      label="Último Acesso - Fim"
                      fullWidth
                      clearLabel="Limpar"
                      invalidDateMessage="Data inválida"
                      autoOk
                      onChange={date =>
                        setDateForm({
                          ...dateForm,
                          last_seen_at_date_end: date,
                        })
                      }
                      format="dd/MM/yyyy"
                    />
                  </Grid>
                </>
              )}

              <Grid
                item
                xs={12}
                container
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  className={styles.btnAdd}
                  style={{ marginTop: '1.5em' }}
                >
                  <SearchIcon />
                  {` Filtrar`}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </BaseFilterModal>
    </>
  )
}
